export const dateFormat = new Intl.DateTimeFormat("nb-NO", {year: '2-digit', month: '2-digit', day: '2-digit'})
export const dateTimeFormat = new Intl.DateTimeFormat("nb-NO", {year: '2-digit', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit'})
